<template>
    <div class="columns has-background-white dropdown-selectors is-centered">
        <div class="column is-narrow">
            <div class="columns has-dropdown is-centered">
                <div class="has-text-primary has-text-weight-bold is-size-4">Unterkonstruktion</div>
            </div>
            <div class="column">
                <div class="select">
                    <select class="selectors" v-model="catIdUnterkonstruktion">
                        <option :value="null">Bitte wählen</option>
                        <option v-for="(cat, index) in categoryUnterkonstruktion" :key="index" :value="cat.id">{{ cat.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="column is-narrow">
            <div class="columns has-dropdown is-centered">
                <div class="has-text-primary has-text-weight-bold is-size-4">Material</div>
            </div>
            <div class="column">
                <div class="select">
                    <select class="selectors" v-model="catIdMaterial">
                        <option :value="null">Bitte wählen</option>
                        <option v-for="(cat, index) in categoryMaterial" :key="index" :value="cat.id">{{ cat.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="column is-narrow">
            <div class="columns has-dropdown is-centered">
                <div class="has-text-primary has-text-weight-bold is-size-4">Schraubenart</div>
            </div>
            <div class="column">
                <div class="select">
                    <select class="selectors" v-model="catIdSchraubenart">
                        <option :value="null">Bitte wählen</option>
                        <option v-for="(cat, index) in categorySchraubenart" :key="index" :value="cat.id">{{ cat.name }}</option>
                    </select>
                </div>
            </div>
        </div>
            <div class="column is-narrow" v-if="currentProduct">
            <div class="columns has-dropdown is-centered">
                <div class="has-text-primary has-text-weight-bold is-size-4">Produkt</div>
            </div>
            <div class="column">
                <div class="select">
                    <select class="selectors" v-model="currentProduct">
                        <option :value="null">Bitte wählen</option>
                        <option v-for="(prod, index) in filteredProducts" :key="index" :value="prod">{{ prod.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="column is-narrow" v-if="currentProduct && optionFor(firstVariation, 'dicht-scheibe')">
            <div class="columns has-dropdown is-centered">
                <div class="has-text-primary has-text-weight-bold is-size-4">Dichtscheibe[mm]</div>
            </div>
            <div class="column">
                <div class="select">
                    <select class="selectors" v-model="dichtScheibeValue" @change="emitSetDichtScheibeFilter">
                        <option v-for="(variationValue, index) in dichtscheibeVariationValues" :key="index">{{ variationValue }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                //dichtScheibeValue: "16",
                
            }
        },
        computed: {
            currentProduct: {
                set (val) {
                    this.$store.commit('setCurrentProduct', val)
                },
                get () {
                    return this.$store.state.currentProduct
                }
            },
            categories () {
                return this.$store.state.categories
            },
            categoryUnterkonstruktion () {
                return this.categories.filter(cat => cat.parent === this.categoryIdUnterkonstruktion)
            },
            categoryMaterial () {
                return this.categories.filter(cat => cat.parent === this.categoryIdMaterial)
            },
            categorySchraubenart () {
                return this.categories.filter(cat => cat.parent === this.categoryIdSchraubenart)
            },
            // is indicator for what columns in the table are needed
            firstVariation () {
                return this.currentProduct.variations[0]
            },
            filteredProducts () {
                return this.$store.getters.filteredProducts
            },
            catIdUnterkonstruktion: {
                set (val) {
                    this.$store.commit('setCatIdUnterkonstruktion', val)
                },
                get () {
                    return this.$store.state.catIdUnterkonstruktion
                }
            },
            catIdMaterial: {
                set (val) {
                    this.$store.commit('setCatIdMaterial', val)
                },
                get () {
                    return this.$store.state.catIdMaterial
                }
            },
            catIdSchraubenart: {
                set (val) {
                    this.$store.commit('setCatIdSchraubenart', val)
                },
                get () {
                    return this.$store.state.catIdSchraubenart
                }
            },
            dichtscheibeVariationValues () {
                const arr = this.currentProduct.variations.map(v => this.optionFor(v, 'dicht-scheibe'))
                let filtered = arr.filter((v, i, a) => a.indexOf(v) === i)
                const sortFiltered = filtered.sort((a, b) => a.localeCompare(b))

                return sortFiltered
            },
            dichtScheibeValue: {
                get () {
                    if (this.dichtscheibeVariationValues.length > 0) {
                        this.$emit('setDichtScheibeFilter', this.dichtscheibeVariationValues[0])
                        return this.dichtscheibeVariationValues[0]
                    } else {
                        return ""
                    }
                },
                set (val) {
                    return val
                }
            }
        },
        methods: {
            optionFor (variation, attributeName) {
                const foundOption = variation.attributes.find(attr => attr.name === attributeName)
                if (foundOption) {
                    return foundOption.option
                } else {
                    return null
                }
            },
            emitSetDichtScheibeFilter (e) {
                let returnValue = e.target.value
                if (returnValue === "0") {
                    returnValue = null
                }
                this.$emit('setDichtScheibeFilter', returnValue)
            }
        }
    }

</script>

<style lang="sass" scoped>
@import "../assets/sass/main.sass"

.dropdown-selectors
    margin: 50px 0 0 0
    justify-content: space-evenly!important

.has-dropdown
    padding-top: 20px

.selectors
    background-color: $grey-lighter!important

</style>